import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  ChevronIcon2
} from './SVGIcons';

import Social from './Social'

class App extends Component {
  render() {

    const { data, showWindow } = this.props
    const { pricelist } = data

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.27734 6.66016H13.2148" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.78516 6.66016L5.34766 7.22266L7.03516 5.53516" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.27734 11.9102H13.2148" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.78516 11.9102L5.34766 12.4727L7.03516 10.7852" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Прайс-лист</div>
            </div>
          </div>
          <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(pricelist?.title1)}</h2>
          <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start tracking-[-0.02em]'>{Parser(pricelist?.text1)}</div>
          <div className='flex items-start flex-col xl:flex-row gap-[10px] mt-[20px] 2xl:mt-[30px]'>
            <div className='bg-[#F5F7F9] rounded-[15px] p-[20px] flex-none w-full xl:w-[559px]'>
              <div className='text-[#032432] text-[16px] xl:text-[18px]'>{Parser(pricelist?.title2)}</div>
              <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(pricelist?.text2)}</div>
              <div className='flex flex-col xl:flex-row items-end justify-between gap-[10px] mt-[14px]'>
                <div>
                  <div className='text-[#032432] text-[16px] xl:text-[18px]'>{Parser(pricelist?.title3)}</div>
                  <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(pricelist?.text3)}</div>
                </div>
                <a href={`tel:${data?.phone.replace(/[-()\s]/g, '')}`} className='flex w-full justify-center text-[14px] xl:text-[16px] xl:w-auto items-center gap-[9px] h-[38px] xl:h-[50px] px-[28px] bg-[#009EE3] text-white rounded-full cursor-pointer whitespace-nowrap'>
                  <div>{data?.phone}</div>
                  <ChevronIcon2 stroke="white" />
                </a>
              </div>
            </div>
            <div className='bg-[#032432] rounded-[15px] bg-left bg-no-repeat flex items-end flex-1 flex-col xl:flex-row'
              style={{ backgroundImage: `url("${pricelist?.fon}")` }}
            >
              <div className='p-[20px]'>
                <div className='text-white text-[18px]'>{Parser(pricelist?.title4)}</div>
                <div className='text-white/60 mt-[10px] text-[14px] tracking-[-0.02em]'>{Parser(pricelist?.text4)}</div>
                <div className='mt-[26px] flex items-center gap-[12px] flex-col-reverse xl:flex-row w-full xl:w-auto'>
                  <div className='flex items-center gap-[4px] w-full xl:w-auto'>
                    <div onClick={() => showWindow()} className='text-[14px] xl:text-[16px] tracking-[-0.02em] flex flex-1 xl:flex-auto justify-center items-center gap-[9px] h-[38px] xl:h-[50px] px-[24px] bg-[#009EE3] text-white rounded-full cursor-pointer'>
                      <div>Связаться</div>
                      <ChevronIcon2 stroke="white" />
                    </div>
                    <div className='hidden xl:flex flex-col gap-[2px]'>
                      <Social social={data?.social || []} width={24} />
                    </div>
                    <div className='xl:hidden flex items-center gap-[5px]'>
                      <Social social={data?.social || []} width={38} />
                    </div>
                  </div>
                  <div className='w-full xl:w-auto'>
                    <div className='text-[16px] xl:text-[18px] text-white'>Возникли вопросы?</div>
                    <div className='mt-[1px] text-white/60 text-[14px] xl:text-[16px]'>Свяжитесь с нами</div>
                  </div>
                </div>
              </div>
              <div className='w-[315px] xl:w-[177px] h-[200px] xl:h-[0px] mx-auto xl:mx-0 xl:mr-[36px] flex-none flex items-end'>
                <a target="_blank" href={pricelist?.file} className='bg-cover w-full h-[200px] xl:h-[208px] flex items-end xl:items-center pb-[20px] xl:pb-0 justify-center'
                  style={{ backgroundImage: `url("${pricelist?.img}")` }}
                >
                  <div className='flex items-center gap-[9px] h-[38px] px-[15px] bg-white text-[#032432] rounded-full cursor-pointer text-[14px] xl:text-[16px]'>
                    <div>Прайс-лист</div>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.98975 8.75977L8.90975 10.6798L10.8297 8.75977" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M8.91016 3V10.6275" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M15 9.13477C15 12.4498 12.75 15.1348 9 15.1348C5.25 15.1348 3 12.4498 3 9.13477" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;